module.exports = __webpack_public_path__ + "img/main-img.a6199ce8.png";